import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useEffect,
} from 'react';
import { Form, Cascader, Input, Radio, Space, Select, Checkbox } from 'antd';
import { QSarr, CRMData, HCMData } from '@model';
import { IndividualRadio, IndividualCheckBox } from '@components';
import { deepCopy } from '@utils/common';

// import '@style/modules/questionnaires/execution.scss';
import '../../../styles/modules/questionnaires/execution.scss';

const { Item } = Form;
const { TextArea } = Input;
const { Option } = Select;

function Execution(props, ref) {
  const {
    options,
    // values,
    steps,
  } = props;
  const [form] = Form.useForm();
  const [data, setData] = useState({});

  useEffect(() => {
    const obj = steps?.answer || {};
    const optionsArr =
      options?.type === '33' ? CRMData : options?.type === '34' ? HCMData : [];
    // console.log(obj, 'answer');

    let executionData = {};
    let newObj = {};

    Object.keys(QSarr).forEach((item) => {
      if (`QS${options?.type}` === item) {
        executionData = QSarr[item];
      }
    });

    if (options?.type === '28') {
      newObj = { choice: parseInt(obj.choice) - 1, text: obj.text };
    }

    if (
      options?.type === '29' ||
      options?.type === '30' ||
      options?.type === '31' ||
      options?.type === '37'
    ) {
      newObj = { choice: parseInt(obj.choice) - 1 };
    }

    if (
      options?.type === '32' ||
      options?.type === '33' ||
      options?.type === '34' ||
      options?.type === '35' ||
      options?.type === '36'
    ) {
      const buyerObj = {};
      const targetObj = {};
      if (options?.type === '32') {
        if (obj?.buyer?.vendor === 'Other') {
          buyerObj.buyer = ['Other'];
          buyerObj.buyerOther = obj?.buyer?.other;
          executionData.buyer.forEach((item) => {
            if (item.hasShow && item.type === 'Input') {
              if (item.hasShow) {
                item.isShow = true;
              }
            }
            if (item.hasShow && item.type === 'Div') {
              if (item.hasShow) {
                item.isShow = false;
              }
            }
          });
        } else if (obj?.buyer?.vendor) {
          buyerObj.buyer = [obj?.buyer?.vendor, obj?.buyer?.version];
          executionData.buyer.forEach((item) => {
            if (item.hasShow && item.type === 'Div') {
              if (item.hasShow) {
                item.isShow = true;
                item.children = (
                  <div>
                    {obj?.buyer?.vendor === 'SAP' ||
                    obj?.buyer?.vendor === 'Oracle' ||
                    obj?.buyer?.vendor === 'Microsoft'
                      ? 1
                      : 2}
                  </div>
                );
              }
            }
            if (item.hasShow && item.type === 'Input') {
              if (item.hasShow) {
                item.isShow = false;
              }
            }
          });
        } else {
          buyerObj.buyer = [];
        }

        if (obj?.target?.vendor === 'Other') {
          targetObj.target = ['Other'];
          buyerObj.targetOther = obj?.target?.other;
          executionData.target.forEach((item) => {
            if (item.hasShow && item.type === 'Input') {
              if (item.hasShow) {
                item.isShow = true;
              }
            }
            if (item.hasShow && item.type === 'Div') {
              if (item.hasShow) {
                item.isShow = false;
              }
            }
          });
        } else if (obj?.target?.vendor) {
          targetObj.target = [obj?.target?.vendor, obj?.target?.version];
          executionData.target.forEach((item) => {
            if (item.hasShow && item.type === 'Div') {
              if (item.hasShow) {
                item.isShow = true;
                item.children = (
                  <div>
                    {obj?.target?.vendor === 'SAP' ||
                    obj?.target?.vendor === 'Oracle' ||
                    obj?.target?.vendor === 'Microsoft'
                      ? 1
                      : 2}
                  </div>
                );
              }
            }
            if (item.hasShow && item.type === 'Input') {
              if (item.hasShow) {
                item.isShow = false;
              }
            }
          });
        } else {
          targetObj.target = [];
        }
      }

      if (options?.type === '33' || options?.type === '34') {
        if (obj?.buyer?.application === 'Other') {
          buyerObj.buyer = obj?.buyer?.application;
          buyerObj.buyerOther = obj?.buyer?.other;
          executionData.buyer.forEach((item) => {
            if (item.hasShow) {
              if (item.hasShow) {
                item.isShow = true;
              }
            }
          });
        } else if (optionsArr.includes(obj?.buyer?.application)) {
          buyerObj.buyer = obj?.buyer?.application;
          executionData.buyer.forEach((item) => {
            if (item.hasShow) {
              if (item.hasShow) {
                item.isShow = false;
              }
            }
          });
        } else {
          buyerObj.buyer = null;
        }

        if (obj?.target?.application === 'Other') {
          targetObj.target = obj?.target?.application;
          targetObj.targetOther = obj?.target?.other;
          executionData.target.forEach((item) => {
            if (item.hasShow) {
              if (item.hasShow) {
                item.isShow = true;
              }
            }
          });
        } else if (optionsArr.includes(obj?.target?.application)) {
          targetObj.target = obj?.target?.application;
          executionData.target.forEach((item) => {
            if (item.hasShow) {
              if (item.hasShow) {
                item.isShow = false;
              }
            }
          });
        } else {
          targetObj.target = null;
        }
      }

      if (options?.type === '35' || options?.type === '36') {
        buyerObj.buyervendor = obj?.buyer?.vendor;
        buyerObj.buyerapplication = obj?.buyer?.application;
        buyerObj.targetvendor = obj?.target?.vendor;
        buyerObj.targetapplication = obj?.target?.application;
      }

      newObj = {
        ...buyerObj,
        ...targetObj,
        buyerradio: parseInt(obj?.buyer?.radio) - 1,
        targetradio: parseInt(obj?.target?.radio) - 1,
        buyerchecker:
          obj?.buyer?.checker && changeTypeHandler(obj?.buyer?.checker),
        targetchecker:
          obj?.target?.checker && changeTypeHandler(obj?.target?.checker),
      };
    }

    let withNoApplicationObj = {
      buyerNoApplication: obj?.buyer?.noApplication,
      targetNoApplication: obj?.target?.noApplication,
    };
    if (
      options?.type === '32' ||
      options?.type === '33' ||
      options?.type === '34' ||
      options?.type === '35' ||
      options?.type === '36'
    ) {
      Object.keys(newObj).forEach((key) => {
        if (key.includes('buyer')) {
          if (obj?.buyer?.noApplication) {
            delete newObj[key];
          } else {
            withNoApplicationObj[key] = newObj[key];
          }
        }
        if (key.includes('target')) {
          if (obj?.target?.noApplication) {
            delete newObj[key];
          } else {
            withNoApplicationObj[key] = newObj[key];
          }
        }
      });
    } else {
      withNoApplicationObj = newObj;
    }

    Array.isArray(executionData.buyer) &&
      executionData.buyer.map((item) => {
        item.disabled = obj?.buyer?.noApplication;
        return item;
      });

    Array.isArray(executionData.target) &&
      executionData.target.map((item) => {
        item.disabled = obj?.target?.noApplication;
        return item;
      });

    form.setFieldsValue(withNoApplicationObj);
    setData(deepCopy(executionData));
  }, [options?.type]);

  const changeTypeHandler = (arr = [], type) => {
    const newArr = arr.map((item) => {
      if (type === 'toString') {
        item = `${item + 1}`;
      } else {
        item = parseInt(item) - 1;
      }
      return item;
    });
    return newArr;
  };

  const versionHandler = (arr, params, otherVal) => {
    let obj = {};
    if (Array.isArray(arr) && arr.length) {
      if (arr[0] === params) {
        obj = {
          vendor: arr[0],
          version: null,
          other: otherVal || null,
        };
      } else {
        obj = {
          vendor: arr[0],
          version: arr[1],
        };
      }
    } else {
      obj = {
        vendor: null,
        version: null,
      };
    }
    return obj;
  };

  const applicationHandler = (str, params, otherVal) => {
    let obj = {};
    if (str === params) {
      obj = {
        application: str,
        other: otherVal || null,
      };
    } else {
      obj = { application: str || null };
    }
    return obj;
  };

  useImperativeHandle(ref, () => {
    const getValues = () => {
      let answer = {};
      const res = form.getFieldsValue();
      if (options?.type === '28') {
        answer = {
          choice:
            res.choice || res.choice === 0 ? `${Number(res.choice) + 1}` : null,
          text: res.text || null,
        };
      } else if (
        options?.type === '29' ||
        options?.type === '30' ||
        options?.type === '31' ||
        options?.type === '37'
      ) {
        answer = {
          choice:
            res.choice || res.choice === 0
              ? `${`${Number(res.choice) + 1}`}`
              : null,
        };
      } else if (options?.type === '32') {
        answer = {
          buyer: {
            ...versionHandler(res.buyer, 'Other', res.buyerOther),
            radio: res.buyerradio > -1 ? `${res.buyerradio + 1}` : null,
            checker: changeTypeHandler(res.buyerchecker, 'toString') || [],
            noApplication: res.buyerNoApplication || false,
          },
          target: {
            ...versionHandler(res.target, 'Other', res.targetOther),
            radio: res.targetradio > -1 ? `${res.targetradio + 1}` : null,
            checker: changeTypeHandler(res.targetchecker, 'toString') || [],
            noApplication: res.targetNoApplication || false,
          },
        };
      } else if (options?.type === '33' || options?.type === '34') {
        answer = {
          buyer: {
            ...applicationHandler(res.buyer, 'Other', res.buyerOther),
            radio: res.buyerradio > -1 ? `${res.buyerradio + 1}` : null,
            checker: changeTypeHandler(res.buyerchecker, 'toString') || [],
            noApplication: res.buyerNoApplication || false,
          },
          target: {
            ...applicationHandler(res.target, 'Other', res.targetOther),
            radio: res.targetradio > -1 ? `${res.targetradio + 1}` : null,
            checker: changeTypeHandler(res.targetchecker, 'toString') || [],
            noApplication: res.targetNoApplication || false,
          },
        };
      } else {
        answer = {
          buyer: {
            vendor: res.buyervendor || null,
            application: res.buyerapplication || null,
            radio: res.buyerradio > -1 ? `${res.buyerradio + 1}` : null,
            checker: changeTypeHandler(res.buyerchecker, 'toString') || [],
            noApplication: res.buyerNoApplication || false,
          },
          target: {
            vendor: res.targetvendor || null,
            application: res.targetapplication || null,
            radio: res.targetradio > -1 ? `${res.targetradio + 1}` : null,
            checker: changeTypeHandler(res.targetchecker, 'toString') || [],
            noApplication: res.targetNoApplication || false,
          },
        };
      }
      return answer;
    };
    return { values: getValues };
  });

  const noApplicationCheckBoxHandler = (bool, taxonomy) => {
    const nameArr = [];
    data[taxonomy].forEach((item) => {
      item.name && nameArr.push(item.name);
      item.disabled = bool;
    });
    setData(deepCopy(data));
    bool && form.resetFields(nameArr);
  };

  const answerItem = (arr, taxonomy) =>
    Array.isArray(arr) &&
    arr.map((item = {}, idx) => {
      if (item.type === 'Cascader') {
        return (
          <div className={item.containerName}>
            <Item
              name={item.name}
              className={`${item.className} ${item.disabled && 'BPSIdisabled'}`}
              key={item.id}
              style={item.itemStyles}
              label={item.label}
              rules={item.rules}
            >
              <Cascader
                options={item.options}
                disabled={item.disabled}
                size={item.size}
                key={item.id}
                allowClear={false}
                popupClassName="execution"
                displayRender={(label) => label[0] && label.join('-')}
                onChange={(val) => {
                  data[taxonomy].forEach((item) => {
                    let text = val[0];
                    text === 'SAP' || text === 'Oracle' || text === 'Microsoft'
                      ? (text = 1)
                      : (text = 2);
                    if (val[0] === 'Other') {
                      if (item.type === 'Input' && item.hasShow) {
                        item.isShow = true;
                      }
                      if (item.type === 'Div' && item.hasShow) {
                        item.isShow = false;
                      }
                    } else {
                      if (item.type === 'Input' && item.hasShow) {
                        item.isShow = false;
                      }
                      if (item.type === 'Div' && item.hasShow) {
                        item.isShow = true;
                        item.children = <div>{text}</div>;
                      }
                    }
                  });
                  setData(deepCopy(data));
                }}
              />
            </Item>
            {item.hasCheckbox && (
              <Item
                name={item.checkBoxAttr.name}
                style={item.checkBoxAttr.itemStyles}
                label={item.checkBoxAttr.label}
                valuePropName="checked"
                className={item.checkBoxAttr.className}
              >
                <Checkbox
                  checked={item.checkBoxAttr.checked}
                  onChange={(ele) => {
                    noApplicationCheckBoxHandler(ele.target.checked, taxonomy);
                  }}
                />
              </Item>
            )}
          </div>
        );
      } else if (item.type === 'Input') {
        return (
          <div className={item.containerName}>
            <Item
              name={item.name}
              key={item.id}
              style={item.itemStyles}
              rules={item.rules}
              label={item.label}
              className={`${item.classname} ${
                item.hasShow
                  ? item.isShow
                    ? 'inlineBlock'
                    : 'displayNone'
                  : 'inlineBlock'
              } `}
            >
              <Input
                size={item.size}
                placeholder={item.placeholder}
                disabled={item.disabled}
              />
            </Item>
            {item.hasCheckbox && (
              <Item
                name={item.checkBoxAttr.name}
                style={item.checkBoxAttr.itemStyles}
                label={item.checkBoxAttr.label}
                valuePropName="checked"
                className={item.checkBoxAttr.className}
              >
                <Checkbox
                  checked={item.checkBoxAttr.checked}
                  onChange={(ele) => {
                    noApplicationCheckBoxHandler(ele.target.checked, taxonomy);
                  }}
                />
              </Item>
            )}
          </div>
        );
      } else if (item.type === 'Select') {
        return (
          <div className={item.containerName}>
            <Item
              name={item.name}
              key={item.id}
              style={item.itemStyles}
              rules={item.rules}
              label={item.label}
              className={item.classname}
            >
              <Select
                dropdownClassName="execution"
                disabled={item.disabled}
                placeholder={item.placeholder}
                onChange={(val) => {
                  data[taxonomy].forEach((item) => {
                    if (item.hasShow && val === 'Other') {
                      item.isShow = true;
                    } else {
                      item.isShow = false;
                    }
                  });
                  setData(deepCopy(data));
                }}
              >
                {item.options.map((item, idx) => (
                  <Option value={item} key={idx}>
                    {item}
                  </Option>
                ))}
              </Select>
            </Item>
            {item.hasCheckbox && (
              <Item
                name={item.checkBoxAttr.name}
                style={item.checkBoxAttr.itemStyles}
                label={item.checkBoxAttr.label}
                valuePropName="checked"
                className={item.checkBoxAttr.className}
              >
                <Checkbox
                  checked={item.checkBoxAttr.checked}
                  onChange={(ele) => {
                    noApplicationCheckBoxHandler(ele.target.checked, taxonomy);
                  }}
                />
              </Item>
            )}
          </div>
        );
      } else if (item.type === 'IndividualRadio') {
        return (
          <IndividualRadio
            data={item.arr}
            key={item.id}
            name={item.name}
            disabled={item.disabled}
            style={item.itemStyles}
            isShowDownText={item.isShowDownText}
            titleStyles={item.titleStyles}
            upTextStyles={item.upTextStyles}
            radioBoxName={item.radioBoxName}
          />
        );
      } else if (item.type === 'IndividualCheckBox') {
        return (
          <IndividualCheckBox
            key={item.id}
            data={item.arr}
            name={item.name}
            disabled={item.disabled}
            style={item.itemStyles}
            isShowDownText={item.isShowDownText}
            checkBoxName={item.checkBoxName}
          />
        );
      } else if (item.type === 'Checkbox') {
        return (
          <Item
            name={item.name}
            key={item.id}
            style={item.itemStyles}
            rules={item.rules}
            label={item.label}
            valuePropName="checked"
          >
            <Checkbox
              size={item.size}
              placeholder={item.placeholder}
              disabled={item.disabled}
            />
          </Item>
        );
      } else if (item.type === 'TextArea') {
        return (
          <Item
            name={item.name}
            key={item.id}
            style={item.itemStyles}
            rules={item.rules}
            label={item.label}
            className={item.classname}
          >
            <TextArea autoSize={item.autoSize} placeholder={item.placeholder} />
          </Item>
        );
      } else if (item.type === 'Radio') {
        return (
          <Item
            name={item.name}
            key={item.id}
            style={item.itemStyles}
            rules={item.rules}
            label={item.label}
            // onChange={(e) => {
            //   console.log(e.target);
            // }}
          >
            <Radio.Group disabled={item.disabled}>
              <Space direction="vertical">
                {item.arr.map((item, radioIdx) => (
                  <Radio key={radioIdx} value={radioIdx}>
                    {item}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </Item>
        );
      } else if (item.type === 'Break') {
        return <br />;
      } else if (item.type === 'Seperator') {
        return (
          <div
            className="seperator"
            key={item.id}
            style={item.seperatorStyles}
          />
        );
      } else if (item.type === 'Div') {
        return (
          <Item
            key={item.id}
            name={item.name}
            style={item.itemStyles}
            rules={item.rules}
            label={item.label}
            className={`${item.classname} ${
              item.hasShow
                ? item.isShow
                  ? 'inlineBlock'
                  : 'displayNone'
                : 'inlineBlock'
            } ${item.disabled && 'BPSIdisabled'}`}
          >
            {item.children ? item.children : item.text}
          </Item>
        );
      }
      return null;
    });
  return (
    <div className="execution-box">
      <Form
        name="execution"
        layout="vertical"
        ref={ref}
        form={form}
        autoComplete="off"
      >
        {Array.isArray(Object.keys(data)) &&
          Object.keys(data).map((item, idx) => (
            <div
              className={`${
                Object.keys(data).length === 1
                  ? 'no-container'
                  : 'company-container'
              }`}
              key={idx}
            >
              {answerItem(data[item], item)}
            </div>
          ))}
      </Form>
    </div>
  );
}

export default forwardRef(Execution);
